import NameTranslationParamMapper from "../../core/service/translations/NameTanslationParamMapper";
import { parseBooleanValue } from "../../util";
import { IOrganisationIndex } from "../model/OrganisationIndex";

const OrganisationIndexParamMapper = (item: IOrganisationIndex) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid),
    harmonized: parseBooleanValue(item.harmonized),
    nameTranslations: (item?.nameTranslations || []).map((item) =>
      NameTranslationParamMapper(item)
    )
  };
};

export default OrganisationIndexParamMapper;
